function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.77683 72.6091V69.5325C5.77683 69.3222 4.95117 69.3222 4.95117 69.5325V72.8279C4.95117 73.0382 5.77683 73.0382 5.77683 72.8279V72.6074V72.6091Z",
  fill: "#7D8189",
  stroke: "#7D8189",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.09824 71.4208V69.5644C6.09824 69.1908 4.63135 69.1908 4.63135 69.5644V71.8112C4.63135 72.1848 6.09824 72.1848 6.09824 71.8112V71.4191V71.4208Z",
  fill: "#A4A9AC",
  stroke: "#A4A9AC",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M34.1924 72.6091V69.5325C34.1924 69.3222 33.3667 69.3222 33.3667 69.5325V72.8279C33.3667 73.0382 34.1924 73.0382 34.1924 72.8279V72.6074V72.6091Z",
  fill: "#7D8189",
  stroke: "#7D8189",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M34.5123 71.4208V69.5644C34.5123 69.1908 33.0454 69.1908 33.0454 69.5644V71.8112C33.0454 72.1848 34.5123 72.1848 34.5123 71.8112V71.4191V71.4208Z",
  fill: "#A4A9AC",
  stroke: "#A4A9AC",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M37.9684 45.4819H1V69.5994H37.9684V45.4819Z",
  fill: "#CCCECF",
  stroke: "#A4A9AC",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M36.0754 1H2.88672V43.5498H36.0754V1Z",
  fill: "#CCCECF",
  stroke: "#A4A9AC",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M33.4056 2.54175H5.55664V42.0099H33.4056V2.54175Z",
  fill: "#CCCECF",
  stroke: "#A4A9AC",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M35.363 6.73743L35.1092 4.19945C35.1007 4.11867 34.967 4.0564 34.8114 4.0564C34.6557 4.0564 34.5221 4.11867 34.5136 4.19945L34.2412 6.73743C34.2378 6.77109 34.2395 6.80475 34.2412 6.83672C34.2412 6.8586 34.2378 6.88048 34.2412 6.90404L34.495 9.44202C34.5035 9.5228 34.6371 9.58507 34.7928 9.58507C34.9484 9.58507 35.0821 9.5228 35.0906 9.44202L35.363 6.90404C35.3663 6.87038 35.3646 6.83841 35.363 6.80475C35.363 6.78287 35.3663 6.7593 35.363 6.73743Z",
  fill: "#A4A9AC"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M34.803 7.10928C34.9628 7.10928 35.0923 6.98043 35.0923 6.82149C35.0923 6.66254 34.9628 6.53369 34.803 6.53369C34.6432 6.53369 34.5137 6.66254 34.5137 6.82149C34.5137 6.98043 34.6432 7.10928 34.803 7.10928Z",
  fill: "#DEDFE0"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M35.363 37.6476L35.1092 35.1096C35.1007 35.0288 34.967 34.9666 34.8114 34.9666C34.6557 34.9666 34.5221 35.0288 34.5136 35.1096L34.2412 37.6476C34.2378 37.6812 34.2395 37.7149 34.2412 37.7469C34.2412 37.7688 34.2378 37.7906 34.2412 37.8142L34.495 40.3522C34.5035 40.433 34.6371 40.4952 34.7928 40.4952C34.9484 40.4952 35.0821 40.433 35.0906 40.3522L35.363 37.8142C35.3663 37.7805 35.3646 37.7486 35.363 37.7149C35.363 37.693 35.3663 37.6695 35.363 37.6476Z",
  fill: "#A4A9AC"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M34.803 38.0177C34.9628 38.0177 35.0923 37.8889 35.0923 37.7299C35.0923 37.571 34.9628 37.4421 34.803 37.4421C34.6432 37.4421 34.5137 37.571 34.5137 37.7299C34.5137 37.8889 34.6432 38.0177 34.803 38.0177Z",
  fill: "#DEDFE0"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M24.0494 8.91675H14.9131V11.4379H24.0494V8.91675Z",
  fill: "#023171"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2227 10.7681H18.9434V10.5729H18.4358V10.27H18.8977V10.0747H18.4358V9.7819H18.9434V9.58667H18.2227V10.7681Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M21.3813 10.7681H22.1021V10.5729H21.5962V10.27H22.0581V10.0747H21.5962V9.7819H22.1021V9.58667H21.3813V10.7681Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5271 9.58667H19.314V10.7681H20.0127V10.5729H19.5271V9.58667Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5625 9.58667H20.3477V10.7681H21.0464V10.5729H20.5625V9.58667Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1143 10.3104L15.7963 9.58667H15.5898V10.7681H15.7963V10.063L16.023 10.5662H16.2057L16.4324 10.063V10.7681H16.6388V9.58667H16.4324L16.1143 10.3104Z",
  fill: "white"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M23.1376 10.2935C23.2273 10.2565 23.2915 10.1673 23.2915 10.0646V9.83575C23.2915 9.69943 23.1799 9.58667 23.0411 9.58667H22.4727V10.7681H22.6858V10.312H22.9109L23.1359 10.7681H23.3711L23.1359 10.2935H23.1376ZM23.0767 10.0175C23.0767 10.0731 23.0327 10.1168 22.9769 10.1168H22.6875V9.7819H22.9769C23.0327 9.7819 23.0767 9.82566 23.0767 9.8812V10.0175Z",
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6119 10.4585C17.6119 10.5224 17.5594 10.5729 17.4968 10.5729H17.3649C17.3006 10.5729 17.2498 10.5207 17.2498 10.4585V9.58667H17.0366V10.5056C17.0366 10.6503 17.1551 10.7681 17.3006 10.7681H17.5628C17.71 10.7681 17.8284 10.6503 17.8284 10.5039V9.58667H17.6153V10.4585H17.6119Z",
  fill: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M4.14893 6.82153H7.05226",
  stroke: "#A4A9AC",
  strokeWidth: 0.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M4.14893 37.7266H7.05226",
  stroke: "#A4A9AC",
  strokeWidth: 0.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M31.377 24.547V20.0029",
  stroke: "#A4A9AC",
  strokeWidth: 0.8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M37.9667 45.4988H1L2.91018 43.5684H36.0566L37.9667 45.4988Z",
  fill: "#A4A9AC",
  stroke: "#A4A9AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M7.37385 48.5759C7.19619 48.2174 6.82566 47.97 6.39592 47.97C5.96617 47.97 5.59564 48.2174 5.41799 48.5759C5.29448 48.7762 5.29786 49.0825 5.29786 49.0825L5.30463 48.0946C5.30463 47.4954 5.79359 47.009 6.39592 47.009C6.99824 47.009 7.4872 47.4954 7.4872 48.0946L7.49397 49.0825C7.49397 49.0825 7.4889 48.7762 7.37385 48.5759Z",
  fill: "#A4A9AC",
  stroke: "#A4A9AC",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M6.39598 50.1428C6.99868 50.1428 7.48726 49.6567 7.48726 49.0572C7.48726 48.4577 6.99868 47.9717 6.39598 47.9717C5.79327 47.9717 5.30469 48.4577 5.30469 49.0572C5.30469 49.6567 5.79327 50.1428 6.39598 50.1428Z",
  fill: "#606770",
  stroke: "#A4A9AC",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M21.3324 65.4205C21.011 64.776 20.3443 64.3316 19.5711 64.3316C18.7979 64.3316 18.1313 64.776 17.8098 65.4205C17.5865 65.7807 17.5933 66.3327 17.5933 66.3327L17.6051 64.5538C17.6051 63.4733 18.4849 62.5981 19.5711 62.5981C20.6573 62.5981 21.5371 63.4733 21.5371 64.5538L21.549 66.3327C21.549 66.3327 21.5405 65.7807 21.3324 65.4205Z",
  fill: "#A4A9AC",
  stroke: "#A4A9AC",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M19.571 68.2428C20.6568 68.2428 21.537 67.3673 21.537 66.2872C21.537 65.2071 20.6568 64.3315 19.571 64.3315C18.4852 64.3315 17.605 65.2071 17.605 66.2872C17.605 67.3673 18.4852 68.2428 19.571 68.2428Z",
  fill: "#606770",
  stroke: "#A4A9AC",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgFallingFilmChiller = function SvgFallingFilmChiller(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 74,
    viewBox: "0 0 39 74",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFallingFilmChiller, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Falling_Film_Chiller.db6f85e7.svg";
export { ForwardRef as ReactComponent };